import React from 'react';
import EmptyPage from '../EmptyPage';

const WorkflowTemplatesPage: React.FC = () => {
  return (
    <EmptyPage
      title="워크플로 템플릿"
      icon="GitBranch"
      description="업무 워크플로 템플릿을 관리합니다."
    />
  );
};

export default WorkflowTemplatesPage;
